import {getAction} from "@/service/http/api";

export default {
  methods:{
    getTree(){
      let para = {pageIndex:1,pageSize:1000};
      getAction(this.url.list, para).then(res => {
        if (res.code === 200) {
          let list = res.data.records;
          let treeData = list.filter(item=>{
            return item.parentId == 0
          });
          let handleData = (data)=>{
            data.forEach(item=>{
              let tempList = list.filter(itm=>{
                return itm.parentId === item.id
              });
              item.children = tempList.sort((a,b)=>{
                return a.sortNo - b.sortNo;
              });
              if(item.children.length>0){
                item.children.forEach((menu,i)=>{
                  menu.index = i;
                });
                handleData(item.children);
              }else{
                delete item.children;
              }
            })
          };
          handleData(treeData);
          this.treeData = treeData;
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/menuTree.js